// Toggle products and cart menus

function toggleMenu(menuName) {
  const menus = document.querySelectorAll('nav[data-menu], aside[data-menu]');

  let isMenuOpen = false;

  menus.forEach((menu) => {
    if (menu.getAttribute('data-menu') === menuName) {
      if (menu.classList.contains('menu-open')) {
        menu.classList.remove('menu-open');
        menu.style.visibility = 'hidden';
        document.getElementById('menu-container').classList.remove('active');
      } else {
        menu.style.visibility = 'visible';
        menu.classList.add('menu-open');
        focusTrap(menu);
        isMenuOpen = true;
      }
    } else {
      // Close other open navs
      menu.classList.remove('menu-open');
      menu.style.visibility = 'hidden';
    }
  });

  document.body.classList.toggle('nav-open', isMenuOpen);
}

window.toggleMenu = toggleMenu;

// Add ways to toggle the menu

document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('button[data-menu]');

  // Event listener for buttons
  buttons.forEach((button) => {
    button.addEventListener('click', function (event) {
      const menuName = event.currentTarget.getAttribute('data-menu');
      toggleMenu(menuName);
    });
  });

  // Use URL param to also trigger a menu open
  const urlParams = new URLSearchParams(window.location.search);
  const menuParam = urlParams.get('menu');
  if (menuParam === 'cart' || menuParam === 'products') {
    toggleMenu(menuParam);
  }
});

// Product menu image swap

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-menu-item]').forEach((item) => {
    item.addEventListener('mouseenter', toggleGraphic);
    item.addEventListener('mouseleave', toggleGraphic);

    function toggleGraphic() {
      const value = this.getAttribute('data-menu-item');
      const targetElement = document.querySelector(
        `[data-menu-graphic="${value}"]`,
      );
      if (targetElement) {
        targetElement.classList.toggle('active');
      }
    }
  });
});

// Menu focus trapping

function focusTrap(element) {
  let focusableElements = [];
  let firstFocusableElement = null;
  let lastFocusableElement = null;

  function getFocusableElements() {
    focusableElements = Array.from(
      element.querySelectorAll('a[href], button:not([disabled])'),
    ).filter((focusable) => !focusable.closest('[inert]'));

    if (focusableElements.length === 0) {
      firstFocusableElement = null;
      lastFocusableElement = null;
      return;
    }

    firstFocusableElement = focusableElements[0];
    lastFocusableElement = focusableElements[focusableElements.length - 1];
  }

  getFocusableElements();

  function handleFocus(event) {
    if (!firstFocusableElement || !lastFocusableElement) return;

    if (event.key === 'Tab') {
      if (event.shiftKey) {
        // Reverse tabbing loop
        if (document.activeElement === firstFocusableElement) {
          event.preventDefault();
          lastFocusableElement.focus();
        }
      } else {
        // Forward tabbing loop
        if (document.activeElement === lastFocusableElement) {
          event.preventDefault();
          firstFocusableElement.focus();
        }
      }
    }
  }

  document.addEventListener('keydown', handleFocus);

  // Set up the MutationObserver to watch for changes in the menu - cart contents are dynamic

  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' || mutation.type === 'attributes') {
        getFocusableElements();
        if (firstFocusableElement) {
          firstFocusableElement.focus();
        }
      }
    }
  });

  observer.observe(element, {
    childList: true,
    subtree: true,
    attributes: true,
  });

  // Disconnect the observer when the menu visibility changes
  element.addEventListener('transitionend', (event) => {
    if (
      event.target === element &&
      getComputedStyle(element).visibility === 'hidden'
    ) {
      observer.disconnect();
      document.removeEventListener('keydown', handleFocus);
    }
  });

  setTimeout(() => {
    if (firstFocusableElement) {
      firstFocusableElement.focus(); // Set focus to first item right away to begin the loop
    }
  }, 200); // Timeout to ensure menu has transitioned or item will not be focusable
}

// Slide in header on scroll

let lastScrollTop = 0;

window.addEventListener('scroll', function () {
  const header = document.getElementById('header');
  const scrollPosition = window.scrollY || document.documentElement.scrollTop;

  if (scrollPosition > lastScrollTop && scrollPosition > 200) {
    // Scrolling down
    header.classList.add('nav-up');
  } else {
    // Scrolling up or at the top of the page
    header.classList.remove('nav-up');
  }

  // Update the last scroll position to the current position
  lastScrollTop = scrollPosition;
});

// Mobile product sub-menu toggle

document.getElementById('product-sub-menu').onclick = function () {
  const content = document.getElementById('product-sub-menu-content');
  content.style.display = content.style.display === 'block' ? 'none' : 'block';
  this.classList.toggle('open');
};

// Submenu toggle

document.querySelectorAll('button[data-submenu-toggle]').forEach((button) => {
  button.addEventListener('click', function () {
    document.getElementById('menu-contents').classList.toggle('active');
    document.querySelectorAll('.tier-1, .tier-2').forEach((element) => {
      element.toggleAttribute('inert');
    });
  });
});
